import { useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { HeadquarterService } from '../../services/headquarters/headquarterService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage headquarters fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de sedes.
----------------------------------------------------------------------------------------*/

const useHeadquarters = (initialFilters = {}) => {
    // STATES
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { userCan } = usePrivilege();
    let filters = {
        limit: 500,
        filter_filters: { ...initialFilters }
    };

    const fetchData = async (f?: any) => {
        if (!userCan('list', 'headquarter')) return;
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        setLoading(true);
        try {
            const response = await (new HeadquarterService()).listForSelect(newFilters);
            const fetchedData = response.getResponseData()?.data;
            if (fetchedData) {
                const mappedData = fetchedData?.map((data: any) => ({
                    value: data.id,
                    label: data.name,
                    pickupSchedule: data.pickupSchedule ?? null,
                    schedules: data.schedules ?? null,
                    providerName: data.providerName ?? null,
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching headquarters:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const getHeadquartersList = (entity?: string | null, notShowStatusID?: Array<string> | null, notShowStatusName?: Array<string> | null) => {
        let dataCopy = [...data];
        if (entity) return dataCopy.filter((state: any) => state.entity === entity);
        if (notShowStatusID && Array.isArray(notShowStatusID)) dataCopy = dataCopy.filter((state: any) => !notShowStatusID.includes(state.value));
        if (notShowStatusName && Array.isArray(notShowStatusName)) dataCopy = dataCopy.filter((state: any) => !notShowStatusName.includes(state.label));
        return dataCopy;
    };

    return { fetchHeadquarters: fetchData, getHeadquartersList, loadingHeadquarters: loading };
}

export default useHeadquarters;